import { fetchAgingPayable } from '../api';
import AgingPage from './AgingPage';

export default function AccountsPayablePage() {
  return (
    <AgingPage
      title="Accounts Payable"
      description="Aging summary of outstanding vendor bills from QuickBooks."
      queryKey="aging-payable"
      fetchFn={fetchAgingPayable}
      csvFilePrefix="ap"
    />
  );
}
